@if ((currentCustomer.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE) && (currentCustomer.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE0)) {

  <div class="customer-info-fidelity-container">
    @if (isLoading) {
      <div class="skeleton-container">
        <div class="info">
          <p-skeleton borderRadius="16px" width="33%"></p-skeleton>
          <p-skeleton borderRadius="16px" width="33%"></p-skeleton>
          <div class="data">
            <p-skeleton borderRadius="16px"></p-skeleton>
            <p-skeleton borderRadius="16px"></p-skeleton>
            <p-skeleton borderRadius="16px"></p-skeleton>
          </div>
        </div>
        <div class="points">
        <span class="casto-title decorator">
          {{ 'fidelity-info.my-points' | translate }}
        </span>
          <p-skeleton styleClass="large-skeleton" height="4rem" borderRadius="16px" />
        </div>
        <div class="rewards">
          <span class="casto-title decorator" [innerHtml]="'fidelity-info.my-rewards' | translate"></span>
          <p-skeleton styleClass="large-skeleton" height="4rem" borderRadius="16px" />
        </div>
      </div>
    } @else {
      @if (currentCustomer.fidelity) {
        <div class="card-info">
          <div class="card-type-img">
            @switch (currentCustomer?.fidelity?.typeCard) {
              @case (FidelityCardTypeEnum.PREMIUM) {
                <img src="../../../../assets/img/ccastomax.png" />
              }
              @case (FidelityCardTypeEnum.GRATUITE) {
                <img src="../../../../assets/img/ccasto.png" />
              }
              @default {

              }
            }
          </div>
          <div class="card-number">
            <div class="casto-title decorator">
              @if (currentCustomer.fidelity.cardIsPaidButNotActiveYet) {
                <span class="blue"
                      [innerHTML]="'fidelity-info.card-type-name.premium-waiting-activation'| translate "></span>
              } @else {
                <span class="blue">{{ currentCustomer?.fidelity?.typeCard | fidelityCardTypeName | translate }}</span>
              }
            </div>
            <div class="card-number-wrapper">
<span
  class="label"
  id="card-number-label"
  [innerHtml]="
                'fidelity-info.card-number' | translate: { number: currentCustomer.fidelity.cardNumber }
              "></span>
              <ng-casto-button [faIcon]="faPrint" [label]="'Imprimer'" (click)="printCard()"></ng-casto-button>
            </div>

            @if (currentCustomer.fidelity.cardIsPaidButNotActiveYet) {
              <div class="pay-button-action">
                <ng-casto-button
                  class="primary"
                  (click)="refreshFidelity()"
                  [label]="'fidelity-info.refresh' | translate"
                  [loading]="refreshLoading">
                </ng-casto-button>
              </div>
            } @else {
              @if (isActive) {
                @if (displayRenewBtn()) {
                  <ng-casto-button
                    class="action"
                    (click)="postRenewPremiumCard()"
                    [label]="'fidelity-info.loyalty-card-validation.renew' | translate">
                  </ng-casto-button>
                } @else {
                  <span class="casto-tag"
                        [innerHTML]="'fidelity-info.active' | translate : {date : dateToString(currentCustomer.fidelity.createdDate)}">
              </span>
                }
                @if (currentCustomer.fidelity?.expiredDate) {
                  <div class="card-date">
                <span
                  class="label"
                  [innerHtml]="'fidelity-info.expire' | translate: { date: dateToString(currentCustomer.fidelity.expiredDate) }"></span>
                  </div>
                }
              }
              @if (currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUMWAITING) {
                <div class="pay-button-action">
                  <ng-casto-button
                    class="primary"
                    (click)="activatePremiumWaitingCard()"
                    [label]="'validation.fidelity.pay' | translate">
                  </ng-casto-button>
                </div>
              }
            }
          </div>
        </div>
        @if (isActive) {
          <div class="points">
          <span class="casto-title decorator">
            {{ 'fidelity-info.my-points' | translate }}
          </span>
            @if (currentCustomer.fidelity) {
              <div class="slider">
                <div class="minmax">
                <span class="blue">
                  {{ 'fidelity-info.points' | translate: { point: minPointValue, s: '' } }}
                </span>
                  <span class="blue">
                  {{ 'fidelity-info.points' | translate: { point: currentCustomer.fidelity.maxPoints, s: 's' } }}
                </span>
                </div>
                <p-slider
                  [ngModel]="currentCustomer.fidelity.points"
                  [min]="minPointValue"
                  [max]="currentCustomer.fidelity.maxPoints"
                  [animate]="true"
                  [styleClass]="'point-slider'"
                  [disabled]="true" />

                <span
                  class="casto-tag"
                  id="point-tag"
                  [style.margin-left.%]="getSliderPosition()">
                  {{
                    'fidelity-info.points' | translate: {
                      point: currentCustomer.fidelity.points,
                      s: currentCustomer.fidelity.points > 1 ? 's' : ''
                    }
                  }}
              </span>
              </div>
            } @else {
              <span class="no-data" [innerHtml]="'fidelity-info.no-point-data' | translate"></span>
            }
          </div>
          <div class="rewards">
            <span class="casto-title decorator" [innerHtml]="'fidelity-info.my-rewards' | translate"></span>

            @if (currentCustomer.fidelity.coupons.offerCouponsList.length > 0) {
              <div class="rewards-list">
                @for (offerCoupon of currentCustomer.fidelity.coupons.offerCouponsList; track offerCoupon) {
                  <ng-casto-offer-coupon-card
                    [title]="offerCoupon.name"
                    [expirationDate]="offerCoupon.usabilityEndDate"></ng-casto-offer-coupon-card>
                }
              </div>
            } @else {
              <span class="no-offer" [innerHTML]="'fidelity-info.no-offer'|translate"></span>
            }
          </div>
          @if (currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.GRATUITE) {
            <div class="upgrade-button-container">
              <ng-casto-button [label]="'validation.fidelity.subscribe'|translate"
                               (click)="createPremiumCard()"
                               class="primary"></ng-casto-button>
            </div>
          }

        }
      } @else {
        <div class="no-card-container">
          <span class="casto-title" [innerHtml]="'fidelity-info.no-data' | translate"></span>
          <div class="form-input" #premium>
            <div class="premium-card-choice">
              <div class="card-choice-container" (click)="this.createFidelityCard({ withPremium: false })">
                <img [src]="'assets/img/c-castoprice.svg'" alt="" class="card">
                <a [href]="loyaltyUrl.fidelityLearnMoreFreeCardURL" target="_blank"
                   [innerHTML]="'customer-info-form.fidelity-form.more'|translate"
                   (click)="$event.stopPropagation()"></a>
              </div>
              <div class="card-choice-container" (click)="this.createFidelityCard({ withPremium: true })">
                <img [src]="'assets/img/c-castomaxprice.svg'" alt="" class="card">
                <a [href]="loyaltyUrl.fidelityLearnMorePremiumCardURL" target="_blank"
                   [innerHTML]="'customer-info-form.fidelity-form.more'|translate"
                   (click)="$event.stopPropagation()"></a>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
} @else {
  <div class="no-card-container">
    @if (isLoading) {
      <div class="skeleton-container">
        <div class="info">
          <p-skeleton borderRadius="16px" width="33%"></p-skeleton>
          <p-skeleton borderRadius="16px" width="33%"></p-skeleton>
          <div class="data">
            <p-skeleton borderRadius="16px"></p-skeleton>
            <p-skeleton borderRadius="16px"></p-skeleton>
            <p-skeleton borderRadius="16px"></p-skeleton>
          </div>
        </div>
        <div class="points">
        <span class="casto-title decorator">
          {{ 'fidelity-info.my-points' | translate }}
        </span>
          <p-skeleton styleClass="large-skeleton" height="4rem" borderRadius="16px" />
        </div>
        <div class="rewards">
          <span class="casto-title decorator" [innerHtml]="'fidelity-info.my-rewards' | translate"></span>
          <p-skeleton styleClass="large-skeleton" height="4rem" borderRadius="16px" />
        </div>
      </div>
    } @else {
      <span class="casto-title" [innerHtml]="'fidelity-info.no-data' | translate"></span>
      <div class="form-input" #premium>
        <div class="premium-card-choice">
          <p-button (onClick)="this.createFidelityCard({ withPremium: false })">
            <div class="card-choice-container">
              <img [src]="'assets/img/c-castoprice.svg'" alt="" class="card">
              <a [href]="loyaltyUrl.fidelityLearnMoreFreeCardURL" target="_blank"
                 [innerHTML]="'customer-info-form.fidelity-form.more'|translate"
                 (click)="$event.stopPropagation()"></a>
            </div>
          </p-button>
          <p-button (onClick)="this.createFidelityCard({ withPremium: true })">
            <div class="card-choice-container">
              <img [src]="'assets/img/c-castomaxprice.svg'" alt="" class="card">
              <a [href]="loyaltyUrl.fidelityLearnMorePremiumCardURL" target="_blank"
                 [innerHTML]="'customer-info-form.fidelity-form.more'|translate"
                 (click)="$event.stopPropagation()"></a>
            </div>
          </p-button>
        </div>
      </div>
    }
  </div>
}
